// src/components/common/SparkHeading.tsx

import React from 'react';

interface SparkHeadingProps {
  children: React.ReactNode;
  level?: 'h1' | 'h2' | 'h3' | 'h4';
  glow?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const SparkHeading: React.FC<SparkHeadingProps> = ({
  children,
  level = 'h1',
  glow = false,
  className = '',
  style = {},
}) => {
  const headingClasses = [
    'spark-heading',
    `spark-heading--${level}`,
    glow ? 'glow-text' : '',
    className
  ].filter(Boolean).join(' ');

  const HeadingTag = level;

  return (
    <HeadingTag className={headingClasses} style={style}>
      {children}
    </HeadingTag>
  );
};

export default SparkHeading;